import { render, staticRenderFns } from "./challengeDetail.vue?vue&type=template&id=6a41a816&"
import script from "./challengeDetail.vue?vue&type=script&lang=js&"
export * from "./challengeDetail.vue?vue&type=script&lang=js&"
import style0 from "./challengeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports